module.exports = __webpack_public_path__ + "img/Trash.387755d5.svg";